import { gql } from "@apollo/client";

export const GET_CB_TIPPER_PROFILE = gql`
  query getCBTipperProfile {
    getCBTipperProfile {
      username
      inFanclub
      createdDatetime
      lifetimeBiggestTip
      numberOfTips
    }
  }
`;

export const GET_CB_TIPPER_PROFILE_DETAILS = gql`
  query getCBTipperProfileDetails {
    getCBTipperProfileDetails {
      amount
      count
    }
  }
`;

export const GET_MY_CB_LINK = gql`
  query getMyChaturbateLink {
    getMyChaturbateLink {
      cbUsername
      linkedAt
    }
  }
`;
